import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import "./style.scss";
import { AnimatePresence, motion } from "framer-motion";

const Modal = ({
  className,
  style,
  id,
  nestedGrid,
  disabled,
  onCloseClicked,
  children,
  // state must be passed from parrent
  showModal,
  modalContentClasses,
  modalContentStyles
}) => {
  const modalContentRef = useRef();

  useEffect(() => {
    if (showModal) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }
  }, [showModal]);

  useEffect(() => {
    return () => {
      document.body.style.overflowY = "auto";
    };
  }, []);

  const handleClick = () => {
    if (!disabled && onCloseClicked) {
      onCloseClicked();
    }
  };

  const modalBodyClasses = classNames(
    "modal-content",
    {
      "grid-story": !nestedGrid
    },
    modalContentClasses ? modalContentClasses.join(" ") : null
  );

  const modalClasses = classNames("grid", className);

  const modalAnimations = {
    start: { x: -500, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.3 } },
    exit: { y: +150, opacity: 0, transition: { duration: 0.15 } }
  };

  const modalMaskAnimations = {
    start: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.3 } },
    exit: { opacity: 0, transition: { duration: 0.3 } }
  };

  return (
    <AnimatePresence>
      {showModal && (
        <motion.div className="modal-mask" variants={modalMaskAnimations} initial="start" animate="visible" exit="exit">
          <motion.div className={modalClasses} style={style} id={id} onClick={event => handleClick(event)} variants={modalAnimations} initial="start" animate="visible" exit="exit">
            <div className="modal-wrapper">
              {!disabled && (
                <span className="close" onClick={event => handleClick(event)}>
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
                  </svg>
                </span>
              )}
              <div className="modal" onClick={event => event.stopPropagation()} id={"modal-content"}>
                <div className={modalBodyClasses} ref={modalContentRef}>
                  {children}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

Modal.propTypes = {
  className: PropTypes.string,
  style: PropTypes.string,
  id: PropTypes.string,
  nestedGrid: PropTypes.bool,
  disabled: PropTypes.bool,
  onCloseClicked: PropTypes.func,
  children: PropTypes.node
};

Modal.defaultProps = {
  gridType: "normal"
};

export default Modal;
